import { render, staticRenderFns } from "./LoadDataCom.vue?vue&type=template&id=3c193b94&scoped=true"
import script from "./LoadDataCom.vue?vue&type=script&lang=js"
export * from "./LoadDataCom.vue?vue&type=script&lang=js"
import style0 from "./LoadDataCom.vue?vue&type=style&index=0&id=3c193b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c193b94",
  null
  
)

export default component.exports